module.exports = __webpack_public_path__ + "static/img/Tyson-Frizell.5dd6c63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tyson-Frizell.jpg
// module id = Bgsx
// module chunks = 0